import React, {useContext, useEffect, useState} from "react";
import {
  Box,
  Button,
  Chip, IconButton,
  Modal,
  Stack,
  Typography
} from "@mui/material";
import {IconSettings} from "@tabler/icons-react";
import MultiSelectAutocomplete from "../../../../../components/inputs/multi-select-autocomplete";
import TagManagementModal from "./tag-management-modal";
import {Context as AppContext} from "../../../../../context/AppContext"; // ensure this is the correct path

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: "440px",
  width: "90%",
  maxHeight: "80vh",
  bgcolor: 'background.paper',
  borderRadius: 2,
  border: '0px solid #000',
  boxShadow: 24,
  px: 4,
  py: 3,
  overflowY: "auto"
};

export const TagSelectionModal = ({open, handleClose, node, onUpdate, project}) => {
  const { updateProject } = useContext(AppContext);
  const allTags = project?.settings?.tags || [];

  const initialSelectedUids = project?.settings?.tags?.filter(i => i?.nodes?.includes(node?.id))?.map(i => i?.id) || [];
  const [selectedTags, setSelectedTags] = useState(initialSelectedUids);
  const [manageTagsOpen, setManageTagsOpen] = useState(false);

  useEffect(() => {
    if (open) {
      setSelectedTags(initialSelectedUids); // reset on open
    }
  }, [open]);

  const handleAddTag = (uid) => {
    if (uid && !selectedTags.includes(uid)) {
      setSelectedTags(prev => [...prev, uid]);
    }
  };

  const handleRemoveTag = (uidToRemove) => {
    setSelectedTags(prev => prev.filter(uid => uid !== uidToRemove));
  };

  const handleSave = async () => {
    const nodeId = node.id;

    // Build updated tags with modified `nodes` list
    const updatedTags = allTags.map(tag => {
      const isSelected = selectedTags.includes(tag.id);
      const nodes = Array.isArray(tag.nodes) ? [...tag.nodes] : [];

      const containsNode = nodes.includes(nodeId);

      if (isSelected && !containsNode) {
        nodes.push(nodeId); // add if selected but not already in nodes
      } else if (!isSelected && containsNode) {
        // remove if unselected but present
        const index = nodes.indexOf(nodeId);
        if (index > -1) nodes.splice(index, 1);
      }

      return {
        ...tag,
        nodes
      };
    });

    // await onUpdate({...updatedNode});
    const newProject = {
      ...project,
      settings: {
        ...project.settings,
        tags: updatedTags
      }
    };

    await updateProject(newProject);
    handleClose();
  };


  return (
    <>
      <TagManagementModal
        open={manageTagsOpen}
        handleClose={() => setManageTagsOpen(false)}
        tags={allTags}
        project={project}
      />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Stack direction="column" gap={2} sx={style}>
          <Typography fontWeight={500} fontSize="1.05em">Tag Selection</Typography>

          <Stack direction={"row"} gap={1} alignItems={"flex-end"}>
            {/* Single select autocomplete */}
            <Box sx={{flex: 1}}>
              <MultiSelectAutocomplete
                options={allTags?.filter(i => !selectedTags?.includes(i?.id))}
                selectedValues={null} // always empty to allow one-time pick
                onChange={handleAddTag}
                placeholder="Select a tag..."
                getOptionLabel={(opt) => opt.name}
                getOptionValue={(opt) => opt.id}
                multiple={false}
                blurOnSelect={true}
                clearOnBlur={true}
              />
            </Box>
            <Box>
              <IconButton onClick={() => setManageTagsOpen(true)}><IconSettings/></IconButton>
            </Box>
          </Stack>

          {/* Selected tags as chips */}
          <Stack direction="row" gap={1} flexWrap="wrap">
            {selectedTags.map((uid) => {
              const tag = allTags.find(t => t.id === uid);
              return (
                <Chip
                  key={uid}
                  label={tag?.name || uid}
                  onDelete={() => handleRemoveTag(uid)}
                />
              );
            })}
          </Stack>

          <Stack direction="row" justifyContent="flex-end" gap={1} mt={2}>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleSave} variant="modal">Save</Button>
          </Stack>
        </Stack>
      </Modal>
    </>

  );
};
